/* eslint-disable*/
/* global d3 $ _ */
/* eslint-disable-line */

import { cluster } from "d3";
import { add } from "lodash";
import pipeService from '../../service/pipeService.js';
import dataService from '../../service/dataService.js';

let DrawSubsetView = function(id) {
    this.id = id;
    this.divWidth = $('#' + this.id).width()
    this.divHeight = $('#' + this.id).height()
    this.margin = { top: 0, right: 0, bottom: 0, left: 0 }
    this.width = this.divWidth - this.margin.left - this.margin.right
    this.height = this.divHeight - this.margin.top - this.margin.bottom

    this.hoverDiv = d3.select("body").append("div")
    .attr("class", "tooltip")
    .attr("id", "subsetTooltip")
    .style("opacity", 0)
}

function cutOffText(rawText, maxLength, characterWidth = 7.5) {
    let maxCharacterNum = Math.floor(maxLength / characterWidth);
    let sliced_length = maxCharacterNum - 3;
    if(sliced_length < 0){
        sliced_length = 1;
    }
    if(rawText.length > maxCharacterNum){
        let showText = rawText.slice(0, sliced_length) + "...";
        return showText;
    }else{
        return rawText;
    }
}

function summary_data(data){
    let max_cnt = 0;
    for(let i = 0; i<data.length; i++){
        let above_cnt = data[i].above_cnt;
        let below_cnt = data[i].below_cnt;
        max_cnt = Math.max(max_cnt, above_cnt, below_cnt);

    }
    if(max_cnt<1){
        max_cnt = 1;
    }
    return {
        "max_cnt": max_cnt
    }
}

function drawNodeGlyph(node_enter, additional_info, filterStopWords){

    let bar1_key = "accuracy";
    let bar2_key = "avg_shap_coverage"

    let max_cnt = additional_info["max_cnt"];
    let layout_config = additional_info["layout_config"]
    
    let hoverDiv2 = layout_config["hoverDiv"];
    let glyph_config = layout_config["glyph_config"]

    let rect_width = glyph_config["rect_width"]; // 245
    let rect_height = glyph_config["rect_height"]; // 100
    let upper_rect_height = glyph_config["upper_rect_height"]; // 15
    let upper_rect_gap = glyph_config["upper_rect_gap"]; // 5;
    let middle_gap = glyph_config["middle_gap"] // 5;
    let bottom_rect_height = glyph_config["bottom_rect_height"] // 30;
    let bottom_text_offset = glyph_config["bottom_text_offset"] // 20;
    let main_x = glyph_config["main_x"]
    let outer_margin = glyph_config["outer_margin"];
    // let rect_width = 245;
    // let rect_height = 100;
    // let main_x = 30;
    const stopWordList = ["ourselves", "hers", "between", "yourself", "but", "again", "there", "about", "once", "during", "out", 
    "very", "having", "with", "they", "own", "an", "be", "some", "for", "do", "its", "yours", "such", "into", "of", "most", 
    "itself", "other", "off", "is", "s", "am", "or", "who", "as", "from", "him", "each", "the", "themselves", "until", 
    "below", "are", "we", "these", "your", "his", "through", "don", "nor", "me", "were", "her", "more", "himself", 
    "this", "down", "should", "our", "their", "while", "above", "both", "up", "to", "ours", "had", "she", "all", 
    "no", "when", "at", "any", "before", "them", "same", "and", "been", "have", "in", "will", "on", "does", 
    "yourselves", "then", "that", "because", "what", "over", "why", "so", "can", "did", "not", "now", "under", 
    "he", "you", "herself", "has", "just", "where", "too", "only", "myself", "which", "those", "i", "after", 
    "few", "whom", "t", "being", "if", "theirs", "my", "against", "a", "by", "doing", "it", "how", "further", "was", "here", "than"]
    // Filter stop words in process text step?
    function process_text(d, key, filterStopWords) {
        // console.log("process_text", d[key]);
        let text = "";
        for (let i = 0; i < d[key].length; i++) {
            // console.log("process_text keys", Object.keys(d[key][i]));
            if (filterStopWords && stopWordList.includes(Object.keys(d[key][i])[0])) {
                continue;
            }
            text += Object.keys(d[key][i])[0];
            if (i < d[key].length - 1) {
                text += ", ";
            }
        }
        return text;
    }

    // background
    // let outer_margin = 2;
    node_enter.append("rect")
    .attr("x", -outer_margin)
    .attr("y", -outer_margin)
    .attr("width",rect_width + main_x + 2*outer_margin)
    .attr("height", rect_height+2*outer_margin)
    .attr("stroke", "#000000")
    .attr("stroke-width", (d)=>(d.selected)?2:0)
    .attr("fill", "#ffffff")

    let glyphStokeWidth = 1

    // Acc bar
    node_enter.append("rect")
    .attr("x", main_x)
    .attr("y", 0)
    .attr("width",rect_width)
    .attr("height", upper_rect_height)
    .attr("stroke", "#bbbbbb")
    .attr("stroke-width", glyphStokeWidth)
    .attr("fill", "#ffffff")
    
    node_enter.append("rect")
    .attr("x", main_x)
    .attr("y", 0)
    .attr("width", function(d){/**Acc width */ return rect_width*d[bar1_key];})
    .attr("height", upper_rect_height)
    .attr("fill", "#93C47D")
    .on('mouseover', function (d) {
        hoverDiv2.style("opacity", ".7");
        hoverDiv2.html("Accuracy: " + d[bar1_key])
            .style("left", (d3.event.pageX - 105) + "px")
            .style("top", (d3.event.pageY - 50) + "px");
    })
    .on('mousemove', function (d) {
        hoverDiv2
            .style("left", (d3.event.pageX - 105) + "px")
            .style("top", (d3.event.pageY - 50) + "px");
    })
    .on('mouseout', function (d, i) {
        hoverDiv2.style("opacity", 0);
    })
    
    // Model hit average
    node_enter.append("rect")
        .attr("x", main_x)
        .attr("y", upper_rect_height + upper_rect_gap)
        .attr("width",rect_width)
        .attr("height", upper_rect_height)
        .attr("stroke", "#bbbbbb")
        .attr("stroke-width", glyphStokeWidth)
        .attr("fill", "#ffffff")

    node_enter.append("rect")
        .attr("x", main_x)
        .attr("y", upper_rect_height + upper_rect_gap)
        .attr("width", function(d){ return rect_width*d[bar2_key];})
        .attr("height", upper_rect_height)
        .attr("fill", "#7FBCD2")
        .on('mouseover', function (d) {
            hoverDiv2.style("opacity", ".7");
            hoverDiv2.html("Average Hit Ratio: " + d[bar2_key])
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mousemove', function (d) {
            hoverDiv2
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mouseout', function (d, i) {
            hoverDiv2.style("opacity", 0);
        })
    
    let modelCoverTextStrokeWidth = 1
    
    // Model not cover text
    let model_not_cover_text_y = 2*upper_rect_height + upper_rect_gap + middle_gap; // 40
    node_enter.append("rect")
        .attr("x", main_x)
        .attr("y", model_not_cover_text_y)
        .attr("width",rect_width)
        .attr("height", bottom_rect_height)  // 30
        .attr("stroke", "#bbbbbb")
        .attr("stroke-width", modelCoverTextStrokeWidth)
        .attr("fill", "#ffffff")

    node_enter.append("text")
        .attr("x", main_x)
        .attr("y", model_not_cover_text_y + bottom_text_offset)  // 60
        .attr("text-anchor","left")
        .style("font-size", "12px")
        .text(function(d) { return cutOffText(process_text(d, "cpnet_only_top", filterStopWords), rect_width, 6); })
        .on('mouseover', function (d) {
            hoverDiv2.style("opacity", ".7");
            hoverDiv2.html(process_text(d, "cpnet_only_top", filterStopWords))
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mousemove', function (d) {
            hoverDiv2
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mouseout', function (d, i) {
            hoverDiv2.style("opacity", 0);
        })

    // Model covers text
    let model_cover_text_y = model_not_cover_text_y + bottom_rect_height; // 70
    node_enter.append("rect")
        .attr("x", main_x)
        .attr("y", model_cover_text_y)
        .attr("width",rect_width)
        .attr("height", bottom_rect_height)
        .attr("stroke", "#bbbbbb")
        .attr("stroke-width", modelCoverTextStrokeWidth)
        .attr("fill", "#ffffff")

    node_enter.append("text")
        .attr("x", main_x)
        .attr("y", model_cover_text_y + bottom_text_offset)
        .attr("text-anchor","left")
        .style("font-size", "12px")
        .text(function(d) { return cutOffText(process_text(d, "shap_covers_top", filterStopWords), rect_width, 6); })
        .on('mouseover', function (d) {
            hoverDiv2.style("opacity", ".7");
            hoverDiv2.html(process_text(d, "shap_covers_top", filterStopWords))
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mousemove', function (d) {
            hoverDiv2
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mouseout', function (d, i) {
            hoverDiv2.style("opacity", 0);
        })

    // Model not cover #FFAB40
    node_enter.append("rect")
        .attr("x", 0)   
        .attr("y", function(d) {return model_cover_text_y-bottom_rect_height*d.above_cnt / max_cnt})    // 70 - height
        .attr("width", main_x)
        .attr("height", function(d) {return bottom_rect_height*d.above_cnt / max_cnt})
        .attr("fill", "#FFAB40")
        .on('mouseover', function (d) {
            hoverDiv2.style("opacity", ".7");
            hoverDiv2.html("Above Cnt: " + d.above_cnt)
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mousemove', function (d) {
            hoverDiv2
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 50) + "px");
        })
        .on('mouseout', function (d, i) {
            hoverDiv2.style("opacity", 0);
        })
    // Model cover #3C78D8
    node_enter.append("rect")
    .attr("x", 0)
    .attr("y", model_cover_text_y)
    .attr("width", main_x)
    .attr("height", function(d) {return bottom_rect_height*d.below_cnt / max_cnt})
    .attr("fill", "#3C78D8")
    .on('mouseover', function (d) {
        hoverDiv2.style("opacity", ".7");
        hoverDiv2.html("Below Cnt: " + d.below_cnt)
            .style("left", (d3.event.pageX - 105) + "px")
            .style("top", (d3.event.pageY - 50) + "px");
    })
    .on('mousemove', function (d) {
        hoverDiv2
            .style("left", (d3.event.pageX - 105) + "px")
            .style("top", (d3.event.pageY - 50) + "px");
    })
    .on('mouseout', function (d, i) {
        hoverDiv2.style("opacity", 0);
    })
}
function drawRowsGlyphs(svg, data, label, layout_config, y=20, filterStopWords=false) {
    // Add dots
    console.log("drawRowsGlyph, ", svg, data, label, y)
    
    let additional_info = summary_data(data);
    let x_gap = layout_config["x_gap"];
    let x_start = layout_config["x_start"];
    let rect_height = layout_config["glyph_config"]["rect_height"]
    svg.append("text")
    .attr("x", 20)
    .attr("y", y + rect_height / 2 + 5)
    .attr("text-anchor","left")
    .style("font-size", "12px")
    .text(label);

    let nodes = svg.append("g").selectAll("g")
    .data(data, function(d, index) {
        return d.id;
    });

    let node_enter = nodes.enter().append("g");
    let node_enter_update = nodes.merge(node_enter);
    let hovered_obj = "";
    node_enter_update.attr("transform", function(d, index) {
            if(d.hovered) hovered_obj = this;
            let x = x_start+index*x_gap;
            return "translate(" + x + "," + y + ")"
        }
    );
    additional_info["layout_config"] = layout_config;

    drawNodeGlyph(node_enter, additional_info, filterStopWords)

    node_enter_update.on("click", function(d,i){ 
        // console.log("select cluster", d, i)
        if(d.selected == true){
            pipeService.emitSelectCluster([])
        }else{
            let cluster_info = [{
                "label": label,
                "id": d.id,
                "id_list": d.id_list
            }];
            
            pipeService.emitSelectCluster(cluster_info);
        }
        
        // cluster_glyphs click event
        let target_info = {"view": "subset_view", "target": "cluster_glyphs"}
        let additional_info = {"cluster_id": d.id, "cluster_label": label}
        dataService.saveUserDataWrapper("click", target_info, additional_info);
    })
    .on('mouseover', function (d) {
        if(d.hovered == false){
            // console.log("hover cluster", d)

            let cluster_info = [{
                "label": label,
                "id": d.id
            }];
            
            pipeService.emitHoverCluster(cluster_info);
            // cluster_glyphs hover event
            let target_info = {"view": "subset_view", "target": "cluster_glyphs"}
            let additional_info = {"cluster_id": d.id, "cluster_label": label}
            dataService.saveUserDataWrapper("hover", target_info, additional_info);
        }
        
    })
    .on('mouseout', function (d) {
        if(d.hovered){
            pipeService.emitHoverCluster([]);

        }
    })
    
    return hovered_obj;
}
function getClusterMaxNum(data){
    let cluster_max_num = 1;
    Object.keys(data).forEach(d=>{
        cluster_max_num = Math.max(data[d].length, cluster_max_num);
    })
    return cluster_max_num;
}
function construct_id_to_index_mapping(data){
    let id_to_index_mapping = {};
    data.forEach((d,i)=>{

        id_to_index_mapping[d.id] = i;
    })
    return id_to_index_mapping;
}
function process_links(data, layout_config){
    // Row 1 Anchor Point: x: 180 + 290*(i+1) / 2, y: 20 + 100
    // Row 2 Anchor Point: x: 180 + 290*(i+1) / 2, y: 20 + 120

    // Row 3 Anchor Point: x: 180 + 290*(i+1) / 2, y: 20 + 220
    // Row 4 Anchor Point: x: 180 + 290*(i+1) / 2, y: 20 + 240]

    let item_x_gap = layout_config["x_gap"];
    let item_x_start = layout_config["x_start"];
    let item_y_gap = layout_config["y_gap"];
    let item_y_start = layout_config["y_start"];
    
    let item_y_padding = layout_config["y_padding"];

    let links = [];
    let qc = data["qc"];
    let qc_id_to_index_mapping = construct_id_to_index_mapping(qc);
    let qs = data["context_cpnet"]
    let qs_id_to_index_mapping = construct_id_to_index_mapping(qs);
    let tc = data["tc"];
    let tc_id_to_index_mapping = construct_id_to_index_mapping(tc);
    let index = 0;
    for(let i = 0; i<qc.length; i++){
        let local_links = qc[i].links;
        let hovered1 = qc[i].hovered_links;
        for(let j = 0; j<local_links.length; j++){
            let source = parseInt(local_links[j]["source"]); // qc
            let source_index = qc_id_to_index_mapping[source];
            let target = parseInt(local_links[j]["target"]); // qs
            let target_index = qs_id_to_index_mapping[target];
            let hovered2 = qs[target_index].hovered_links;
            let curr_link = {
                "index": index,
                "source":{
                    "id": source,
                    "x": item_x_start + item_x_gap * (source_index + 1/2),
                    "y": item_y_start + item_y_gap - item_y_padding - 3
                },
                "target":{
                    "id": target,
                    "x": item_x_start + item_x_gap * (target_index + 1/ 2) ,
                    "y": item_y_start + item_y_gap - 3
                },
                "weight": local_links[j]["proportion"],
                "hovered": hovered1 || hovered2
            }
            index ++;
            links.push(curr_link)
        }
    }
    for(let i = 0; i<tc.length; i++){
        let local_links = tc[i].links;
        let hovered1 = tc[i].hovered_links;
        for(let j = 0; j<local_links.length; j++){
            let source = parseInt(local_links[j]["source"]); // tc
            let source_index = tc_id_to_index_mapping[source];
            let target = parseInt(local_links[j]["target"]); // qs
            let target_index = qs_id_to_index_mapping[target];
            let hovered2 = qs[target_index].hovered_links;
            let curr_link = {
                "index": index,
                "source":{
                    "id": source,
                    "x": item_x_start + item_x_gap * (source_index + 1/ 2),
                    "y": item_y_start + item_y_gap * 2
                },
                "target":{
                    "id": target,
                    "x": item_x_start + item_x_gap * (target_index + 1/ 2) ,
                    "y": item_y_start + item_y_gap * 2 - item_y_padding
                },
                "weight": local_links[j]["proportion"],
                "hovered": hovered1 || hovered2
            }
            index ++;
            links.push(curr_link)
        }
    }
    return links;
}
function drawLinks(svg, links_data){
    let top_g = svg.append("g")
    let links = top_g.selectAll("links").data(links_data,d=>d.index);
    let link_enter = links.enter();
    let link_enter_update = link_enter.merge(links);
    link_enter.append("line")
    .attr("x1", d=>d.source.x)
    .attr("y1", d=>d.source.y)
    .attr("x2", d=>d.target.x)
    .attr("y2", d=>d.target.y)
    .attr("stroke", "#D4D4D4") // Link color "#bbbbbb"
    .attr("stroke-width", function(d) { return (d.weight * 10); })
    .attr("opacity", d=>d.hovered?1:0)

}
DrawSubsetView.prototype.layout = function(data, filterStopWords) {
    // console.log("layout subset", data);
    // set the dimensions and margins of the graph
    var width = this.width,
    height = this.height;

    // append the svg object to the body of the page
    d3.select("#"+this.id+"_svg").remove();

    

    /**
     * let rect_width = glyph_config["rect_width"];
    let rect_height = glyph_config["rect_height"];
    let upper_rect_height = glyph_config["upper_rect_height"]; // 15
    let upper_rect_gap = glyph_config["upper_rect_gap"]; // 5;
    let middle_gap = glyph_config["middle_gap"] // 5;
    let bottom_rect_height = glyph_config["bottom_rect_height"] // 30;
    let main_x = glyph_config["main_x"]
     */

    // console.log("width, height", width, height); // 1164.51 283.472

    // GLYPH CONFIG
    let item_x_start = 140; // 
    let item_y_start = 5; // 
    let item_y_padding = 40; // 100 

    let rect_x_padding = 45;
    let rect_y_padding = item_y_padding;
    let rect_width = (width - item_x_start) / 4 - rect_x_padding;
    let rect_height = (height - item_y_start) / 3 - rect_y_padding / 3 * 2;
    let upper_rect_height = 8 / 65 * rect_height; // 15
    let upper_rect_gap = 0; // 5;
    let middle_gap = 5 / 65 * rect_height // 5;
    let bottom_rect_height = 20 / 65 * rect_height // 30;
    let main_x = 30;


    // LAYOUT CONFIG

    let item_x_gap = rect_width + rect_x_padding; // old: 245 + 45
   
    let item_y_gap = rect_height + rect_y_padding; // 100 + 100
    
    




    let layout_config = {
        "x_gap": item_x_gap,
        "x_start": item_x_start,
        "y_gap": item_y_gap,
        "y_start": item_y_start,
        "y_padding": item_y_padding,
        "hoverDiv": this.hoverDiv,
        "glyph_config":{
            "rect_width": rect_width,
            "rect_height": rect_height - 6, // new: 8+0+8+5+20+24 = old: 15+5+15+5+30+30 = 100
            "upper_rect_height": upper_rect_height,
            "upper_rect_gap": upper_rect_gap,
            "middle_gap": middle_gap,
            "bottom_rect_height": bottom_rect_height,
            "bottom_text_offset": bottom_rect_height / 2 + 5,
            "main_x": main_x,
            "outer_margin": 2
        }
    }




    var svg_width = Math.max(this.divWidth, item_x_start+getClusterMaxNum(data)*item_x_gap)
    let hoverDiv = this.hoverDiv;
    var top_svg = d3.select("#"+this.id)
    .append("svg")
    .attr("id", this.id+"_svg")
    .attr("width", svg_width)
    .attr("height", this.divHeight)
    var svg = top_svg.append("g")
    .attr("transform",
        "translate(" + this.margin.left + "," + this.margin.top + ")");
    

    let key_mapping = [
        ["Question Concepts", "qc"],
        ["Question Stems", "context_cpnet"],
        ["Target Concepts", "tc"]
    ]
    let links_Data = process_links(data, layout_config);
    drawLinks(svg, links_Data);
    let hovered_obj = ""
    for(let i = 0; i<key_mapping.length; i++){
        let keys = key_mapping[i];
        let labels = keys[0];
        let key = keys[1];
        let local_hovered_obj = drawRowsGlyphs(svg, data[key], labels, layout_config, item_y_start + item_y_gap*i, filterStopWords);
        if(local_hovered_obj !== ""){
            hovered_obj = local_hovered_obj;
        }
    }
    function CheckHovered(){
        if(d3.event && hovered_obj !== ""){
            // I have hovered obj
            // console.log("check hovered cluster");
            let mouse_x = d3.event.pageX;
            let mouse_y = d3.event.pageY;
            let rect_bounding_box = hovered_obj.getBoundingClientRect();
            let left = rect_bounding_box.x;
            let right = rect_bounding_box.width + left;
            let top = rect_bounding_box.y;
            let bottom = rect_bounding_box.height + rect_bounding_box.y;
            if(mouse_x >= left && mouse_x <= right){
                if(mouse_y >= top && mouse_y <= bottom){
                    return true;
                }
            }
            hoverDiv.style("opacity", 0);
            pipeService.emitHoverCluster([]);


            return false;

        }else{
            return true;
        }
    }
    top_svg.on('mousemove', function (d) {
        // console.log("top_svg mousemove")
        CheckHovered();
    })

}

export default DrawSubsetView